import React from 'react';
import { makeStyles, InputBase, Paper, IconButton } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import colors from '../../../../../themes/main-colors';

const useStyles = makeStyles(theme => ({
  paper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    backgroundColor: colors.white,
    borderRadius: 0,
  },
  input: {
    flex: 1,
    fontSize: 16,
    padding: theme.spacing(1.5, 0, 1.5, 2.5),
  },
  iconButton: {
    padding: 0,
    marginRight: theme.spacing(2.5),
    color: colors.noirBlur,
  },
}));

type SearchAccountProps = {
  placeholder?: string;
  onSearch?: (value: string) => void;
};

const SearchAccount: React.FC<SearchAccountProps> = ({
  placeholder = 'Search accounts',
  onSearch,
}) => {
  const classes = useStyles();
  const [value, setValue] = React.useState('');

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && onSearch) {
      onSearch(value);
    }
  };

  return (
    <Paper className={classes.paper}>
      <InputBase
        placeholder={placeholder}
        className={classes.input}
        value={value}
        onChange={e => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        inputProps={{ 'aria-label': placeholder }}
      />
      <IconButton
        className={classes.iconButton}
        onClick={() => onSearch?.(value)}
        aria-label="Search"
        title="Search"
      >
        <SearchIcon />
      </IconButton>
    </Paper>
  );
};

export default SearchAccount;
